import NavbarItem from "@components/features/navigation/NavbarItem";
import CameraUploadInput from "@components/features/photos/CameraUploadInput";
import CogIcon from "@images/svg/cog.svg?react";
import HomeIcon from "@images/svg/home.svg?react";
import LogoutIcon from "@images/svg/logout.svg?react";
import { PagePath } from "@routing/appUrls";
import { useTranslation } from "react-i18next";
import WhitevisionLogo from "@logos/whitevision.svg?react";
import HublLogo from "@logos/hubl.svg?react";
import useLogout from "@hooks/useLogout";
import { FC, SVGProps } from "react";

type NavbarItemConfig = {
  text: string;
  path?: string;
  icon?: FC<SVGProps<SVGSVGElement>>;
  component?: FC;
  onClick?: () => void;
};

const Navbar = () => {
  const { t } = useTranslation();
  const logout = useLogout();

  const navbarItems: NavbarItemConfig[] = [
    {
      path: PagePath.projectPage,
      text: t("home", {
        ns: "navigation",
      }),
      icon: HomeIcon,
    },
    {
      text: t("camera", {
        ns: "navigation",
      }),
      component: CameraUploadInput,
    },
    {
      path: PagePath.settings,
      text: t("settings", {
        ns: "navigation",
      }),
      icon: CogIcon,
    },
    // {
    //   text: t("logout", {
    //     ns: "authentication",
    //   }),
    //   icon: LogoutIcon,
    //   onClick: logout,
    // },
  ];

  return (
    <header className="navbar">
      <nav className="navbar__bar">
        <div className="navbar__brand">
          <HublLogo className="navbar__logo" />
        </div>
        <ul className="navbar__list">
          {navbarItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavbarItem
                key={item.text}
                to={item.path}
                onClick={item.onClick}
                asChildren={!!item.component}
              >
                {item.component ? (
                  <item.component />
                ) : (
                  <div className="navbar__link-content">
                    {Icon && <Icon className="navbar__icon" />}
                    <div className="navbar__label">{item.text}</div>
                  </div>
                )}
              </NavbarItem>
            );
          })}
        </ul>
      </nav>
    </header>
  );
};

export default Navbar;
